<script>
  import { _ } from "svelte-i18n";
  import { createEventDispatcher } from "svelte";
  import { sharedTimer, sharedTimerMode } from "../../utilities/DataStore";

  function formatTime(time) {
    if (time <= 0){
      time = 0;
    }
    return Math.floor(time / 60) + ":" + ((time % 60) + "").padStart(2, "0");
  }

  let countDownTimerText;

  $: countDownTimerText = formatTime($sharedTimer);

  $: isUrgent = $sharedTimer <= 5 && $sharedTimer > 0;
</script>

<div class="timer-pill" class:urgent={isUrgent} class:prepare={$sharedTimerMode === 'PREPARE'}>
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="10"/>
    <polyline points="12 6 12 12 16 14"/>
  </svg>
  <span class="timer-label">{#if $sharedTimerMode === "PREPARE"}Preparation Time:{:else}{$_("REMAINING_TIME")}{/if}</span>
  <span class="timer-time">{countDownTimerText}</span>
</div>

<style>
  .timer-pill {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0.45rem 1.2rem;
    background: #ffffff;
    border: 1.5px solid #e2eaef;
    border-radius: 999px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    color: #64748b;
    transition: background 0.2s, border-color 0.2s;
  }

  .timer-pill.prepare {
    background: #fefce8;
    border-color: #fde68a;
    color: #92400e;
  }

  .timer-pill.prepare .timer-label {
    color: #92400e;
  }

  .timer-pill.prepare .timer-time {
    color: #b45309;
  }

  .timer-label {
    font-size: 0.8rem;
    font-weight: 500;
    color: #64748b;
  }

  .timer-time {
    font-size: 1.1rem;
    font-weight: 700;
    letter-spacing: 0.03em;
    color: #1e293b;
  }

  .urgent .timer-time {
    color: #dc2626;
  }
</style>
